(function($){
	var _GMM_INDEX_HELP_VIEW_MODEL  = {
		list: ko.observableArray([]),
		iframe_url: ko.observable()
	};
	
	$.PageReadyEntry_IndexHelp = function () {
		console.log('[PageReadyEntry IndexHelp]');		
		$.init();
		var koBindDom=$(".page-help")[0];
		var koBindFlag=$(koBindDom).attr("gmm-bind-flag");
		_GMM_INDEX_HELP_VIEW_MODEL.iframe_url(decodeURIComponent($.getQueryStringByName('url')) || location.protocol + '//' + location.host + '/pc/my/help.html');
		if(koBindFlag!="1"){
			ko.applyBindings(_GMM_INDEX_HELP_VIEW_MODEL,koBindDom);
			$(koBindDom).attr("gmm-bind-flag","1");
		}

	};
})(Zepto)